import { ControlCenterActionConstants } from "../action-constants";
import emptyState from "../store/emptyState";
import globalReducerHelper from "./globalReducerHelper";

const controlCenter = (state = emptyState.controlCenter, action) => {
  if (!state) {
    return {};
  }

  const { type, payload } = action;

  const { correlationId, scope } = payload || {};

  switch (type) {
    case ControlCenterActionConstants.SET_INITIATOR_SOURCE: {
      return Object.assign({}, state, {
        initiatorSource: payload
      });
    }

    case ControlCenterActionConstants.FULL_READY:
      return Object.assign({}, state, {
        fullRendered: true
      });

    case ControlCenterActionConstants.MINI_READY:
      return Object.assign({}, state, {
        miniRendered: true
      });

    case ControlCenterActionConstants.MINI_SHOW: {
      return Object.assign({}, state, {
        miniCorrelationId: correlationId,
        miniOpenScope: scope,
        miniRendered: false,
        miniVisible: true
      });
    }

    case ControlCenterActionConstants.MINI_HIDE: {
      return Object.assign({}, state, {
        miniCorrelationId: null,
        miniOpenScope: null,
        miniRendered: false,
        miniVisible: false
      });
    }

    case ControlCenterActionConstants.FULL_SHOW: {
      return Object.assign({}, state, {
        fullCorrelationId: correlationId,
        fullOpenScope: scope,
        fullRendered: false,
        fullVisible: true
      });
    }

    case ControlCenterActionConstants.FULL_HIDE: {
      return Object.assign({}, state, {
        fullCorrelationId: null,
        fullOpenScope: null,
        fullRendered: false,
        fullVisible: false
      });
    }

    case ControlCenterActionConstants.SET_ERROR: {
      const { error } = action.payload;

      return Object.assign({}, state, {
        error
      });
    }

    case ControlCenterActionConstants.SET_ENABLED: {
      return Object.assign({}, state, {
        enabled: action.payload
      });
    }

    default:
      return globalReducerHelper(
        state,
        type,
        payload?.controlCenter,
        emptyState.controlCenter
      );
  }
};

export default controlCenter;
